import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'shared-message-time',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './message-time.component.html',
  styleUrl: './message-time.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MessageTimeComponent {
  time = input.required<Date>();
}
